let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eU9sx")).then(() => parcelRequire('4faMT'));